import { buildService } from './decorated-service';
import { isEmptyObject } from '../../../core/util';

const api = buildService(`/nasu-svc/service/accounts`);

const hiddenStatuses = ['DELETED', 'LAPSED'];

export const getExistingBanks = async (): Promise<any> => {
  const result = await api.http.get('/');
  const filteredResult = isEmptyObject(result)
    ? []
    : result.filter(bank => !hiddenStatuses.includes(bank.verificationStatus));

  return filteredResult;
};

const verifyApi = buildService(`/nasu-svc/service/account`);

export const verifyChallenegeDeposits = async (
  verifyDepositPayload,
  handleServiceResponse
): Promise<any> => {
  const verificationStatusResults = await verifyApi.http.post(
    '/validation/challenge-deposit',
    verifyDepositPayload,
    { handleServiceResponse, errorCodes: [400, 401, 403, 404, 500] }
  );
  return verificationStatusResults;
};
